// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.snowfall-preview {
  position: relative;
  width: 61.8%;
  height: 100vh;
  background-color: black;
}

#snowfall {
  width: 100%;
  height: 100%;
}

.snowfall-notice {
  position: absolute;
  inset: 0;
  z-index: 10;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  box-sizing: border-box;
  padding: 2rem;
  text-align: center;
  color: white;
  pointer-events: none;
  text-shadow: 0 0 4px black;
}

.snowfall-notice strong {
  font-size: clamp(2rem, 4vw, 3.5rem);
  line-height: 1.2;
}

.snowfall-notice span {
  max-width: 36rem;
  font-size: clamp(1.1rem, 2vw, 1.5rem);
  line-height: 1.5;
}

@media (max-width: 1050px) {
  .snowfall-preview {
    width: 100%;
    height: calc(100vh - 61.8vh);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/snowfall/snowfall.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;;EAEX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;;EAET,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,4BAA4B;EAC9B;AACF","sourcesContent":[".snowfall-preview {\n  position: relative;\n  width: 61.8%;\n  height: 100vh;\n  background-color: black;\n}\n\n#snowfall {\n  width: 100%;\n  height: 100%;\n}\n\n.snowfall-notice {\n  position: absolute;\n  inset: 0;\n  z-index: 10;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n\n  box-sizing: border-box;\n  padding: 2rem;\n  text-align: center;\n  color: white;\n  pointer-events: none;\n  text-shadow: 0 0 4px black;\n}\n\n.snowfall-notice strong {\n  font-size: clamp(2rem, 4vw, 3.5rem);\n  line-height: 1.2;\n}\n\n.snowfall-notice span {\n  max-width: 36rem;\n  font-size: clamp(1.1rem, 2vw, 1.5rem);\n  line-height: 1.5;\n}\n\n@media (max-width: 1050px) {\n  .snowfall-preview {\n    width: 100%;\n    height: calc(100vh - 61.8vh);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
